query MobileSdkIssueDetails($testId: ConditionID!, $issueId: ConditionID!) {
	issues(run_id_eq: $testId, issue_id_eq: $issueId, deleted_eq: { value: false }) {
		type_name
		description
		severity_name
		screenshot
		run_time
		knowledge_base_link
		tags__description
		tags__link
		viewport_width
		viewport_height
		signature
		elements__accessibility_identifier
		elements__accessibility_label
		elements__element_type
		elements__view_id
		elements__content_description
		elements__class_name
		elements__bounding_box_x
		elements__bounding_box_y
		elements__bounding_box_width
		elements__bounding_box_height
		elements__index
	}
}

